import { action } from '@play-co/replicant';
import createActions from 'src/replicant/actions/utils/createActions';
import { Fate } from '../buruburu/fate';
import {
  unscheduleQuizEggChat,
  unscheduleTestingMessages,
} from '../buruburu/petChatbot/petChatbot.scheduledActions';
import ab, { getStateBucketID } from '../ruleset/ab';

export default createActions({
  /** Replicant onLogin action, ran on every login. */
  onLogin: action((state, _: void, api) => {
    // Unschedule chatbot messages.
    api.scheduledActions.unschedule('energyRefilled');

    // Unschedule daily messages.
    api.scheduledActions.unschedule('sendDailyMessage');

    // Unschedule testing messages.
    unscheduleTestingMessages(api);

    delete state.deleteAccountIntent;

    const now = api.date.now();

    // Activate death feature
    // After activation fate will start generation fate with death events
    if (!Fate.api.hasDeathFeatureActivated(state, now)) {
      Fate.api.activateDeathFeature(state, now);
    }

    Fate.api.update(state, now);

    // Reset chatbot analytics message counters
    state.chatbotSentSinceEntry = 0;
    state.chatbotReceivedSinceEntry = 0;
  }),

  /**
   * This action should have been placed in social actions module, but for some reason, actions there
   * are not recognizing postMessage methods listed in the same folder, showing and error in the IDE.
   */
  notifyInvitedUserJoined: action(
    (state, args: { inviterId: string; timeSent: number }, api) => {
      api.postMessage.invitedUserJoined(args.inviterId, {
        invitedUserId: state.id,
        timeSent: args.timeSent,
      });
    },
  ),

  /**
   * Set a cooldown timestamp for a given id. Can be used by multiple features.
   */
  setCooldown: action((state, args: { id: string; timestamp: number }, api) => {
    // Initialize cooldowns object if it doesn't exist
    if (!state.cooldowns) state.cooldowns = {};

    if (state.cooldowns[args.id] === undefined) {
      // Create a new cooldown object ofr the id
      state.cooldowns[args.id] = { timestamp: args.timestamp };
    } else {
      // Update the existing cooldown object by id
      state.cooldowns[args.id].timestamp = args.timestamp;
    }
  }),

  /**
   * Action fired when user reaches entryFinal.
   */
  onEntryFinal: action((state, args: void, api) => {
    // Increase the number of entryFinals for the user.
    if (!state.entryFinalCount) state.entryFinalCount = 0;
    state.entryFinalCount += 1;

    // Only unschedule quiz egg chat if the user is in the enabled bucket.
    if (getStateBucketID(state, ab.tests.TEST_QUIZ_EGG_CHAT) === 'enabled') {
      if (state.entryFinalCount === 1) {
        // Clear quiz egg chat schedule.
        unscheduleQuizEggChat(api);
      }
    }
  }),
});
